var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-99 -146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(111.988 159.036)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(100.288 147.336)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(99 146)",
    fill: "#868686"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 5.24883 5.66551C 5.14222 5.66551 5.03561 5.62482 4.95422 5.54344L 0.122075 0.711292C -0.0406917 0.548525 -0.0406917 0.284842 0.122075 0.122075C 0.284842 -0.0406918 0.548525 -0.0406918 0.711292 0.122075L 5.54344 4.95422C 5.70621 5.11699 5.70621 5.38067 5.54344 5.54344C 5.46205 5.62482 5.35544 5.66551 5.24883 5.66551Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M 5.2527 5.66958C 5.14608 5.66958 5.03947 5.62889 4.95809 5.54751L 0.122075 0.711292C -0.0406918 0.548525 -0.0406918 0.284842 0.122075 0.122075C 0.284842 -0.0406918 0.548525 -0.0406918 0.711292 0.122075L 5.5473 4.95829C 5.71007 5.12106 5.71007 5.38474 5.5473 5.54751C 5.46592 5.62889 5.35931 5.66958 5.2527 5.66958Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M 15.7797 20C 14.8963 20 13.8434 19.7453 12.6637 19.2358C 10.4354 18.2739 7.97216 16.5078 5.72781 14.2633C 0.927198 9.46246 -1.26304 4.13143 0.741847 2.12655L 2.36301 0.505392C 2.68874 0.179451 3.12191 -1.56256e-08 3.58274 -1.56256e-08C 4.04358 -1.56256e-08 4.47674 0.179451 4.80248 0.505392L 7.78702 3.48973C 8.11296 3.81567 8.2922 4.24903 8.2922 4.70966C 8.2922 5.17029 8.11275 5.60366 7.78702 5.9292L 6.78152 6.93469C 6.5569 7.15931 6.60675 7.73713 6.91153 8.44313C 7.28223 9.30132 7.97115 10.2588 8.85151 11.1394C 9.73208 12.0199 10.6898 12.7089 11.548 13.0796C 12.2535 13.3835 12.8314 13.4336 13.0564 13.2094L 14.0619 12.2043C 14.3876 11.8783 14.8208 11.6989 15.2814 11.6989C 15.7423 11.6989 16.1754 11.8783 16.5012 12.2043L 19.4857 15.1886C 20.1581 15.8612 20.1581 16.9554 19.4857 17.6281L 17.8645 19.2492C 17.3642 19.7497 16.6552 19.9996 15.7797 20ZM 3.58274 0.833367C 3.34449 0.833367 3.12069 0.926144 2.95222 1.09461L 1.33106 2.71577C -0.110848 4.15788 1.54836 8.90539 6.31703 13.6741C 8.48895 15.8458 10.8601 17.5491 12.9939 18.4708C 14.9785 19.3278 16.5384 19.3969 17.2753 18.66L 18.8965 17.0389C 19.244 16.6914 19.244 16.1253 18.8965 15.7778L 15.9119 12.7935C 15.575 12.457 14.988 12.4562 14.6511 12.7935L 13.6456 13.7986C 13.1528 14.2914 12.2904 14.3076 11.2175 13.8446C 10.2649 13.4332 9.2155 12.6816 8.26229 11.7286C 7.30929 10.7756 6.55792 9.72614 6.14653 8.77355C 5.68325 7.70051 5.69953 6.83825 6.19231 6.34547L 7.1978 5.33998C 7.36626 5.17152 7.45884 4.94771 7.45884 4.70966C 7.45884 4.47121 7.36606 4.24741 7.1978 4.07894L 4.21326 1.09461C 4.0448 0.926144 3.82099 0.833367 3.58274 0.833367Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8a68224b0867d8d6fa0498635811d2a2.svg";
export { ForwardRef as ReactComponent };